<template>
  <div v-if="this.isDecktop" class="tm-order tm-order-check tm-pro-order-check">
    <preloader :is-visible="isLoading"/>
    <ProRetouchersInactivityTimer
      v-if="downtime !== null"
      :downtime="downtime"
      :new_orders_count="new_orders_count"
      @is-loading="isLoading = $event"
      @retry="fetchDowntime"/>
    <div class="tm-background-dark-white tm-text-small uk-box-shadow-medium tm-senior-retoucher" v-else-if="empty_order === ''">
      <div class="uk-padding-xsmall">
        <div class="uk-grid uk-grid-small pro-retoucher" data-uk-grid>
          <!--левая часть-->
          <div class="uk-width-expand" v-if="creteMainPhotoBlock && !modeEdit">
            <div class="uk-panel-scrollable" style="height: calc(100vh - 20px);resize: none;padding: 0;border: none;">
              <ProRetouchersMainPhotoBlock
                :main_photo_block="main_photo_block"
                :with-faces-visible="withFacesVisible"
                :appVersion="computedAppVersion"
                :zone-visible="zoneVisible"
                :order_number="order_number"
                :zone_photo="zone_photo"
                :fullImageList="fullImageList"
                :afterVisible="afterVisible"
                :isOutChat="isOutChat"
                @is-loading="isLoading = $event"
                @retry="reLoadPage"/>
              <!--ПРЕД/СЛЕД заказы-->
              <div class="uk-background-muted uk-padding-small uk-margin-small-top">
                <prev-orders-block
                  v-if="createPrevBlock"
                  :dataGridCol="'tm-child-width-1-9'"
                  :currRole="'pro-retoucher'"
                  class="uk-animation-slide-small-medium"/>
              </div>
            </div>
          </div>
          <!--Режим редактирования-->
          <div v-show="modeEdit" class="uk-width-expand">
            <div>
              <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                <!--консоль цветных заметок-->
                <div class="uk-width-auto">
                  <div class="tm-pro-comments-color-buttons-panel uk-light uk-flex uk-flex-middle uk-flex-center tm-background-green uk-animation-slide-left">
                    <div class="uk-grid uk-grid-small uk-child-width-1-1 uk-flex-center" data-uk-grid>
                      <div>
                        <button
                          @click="resetCanvas"
                          type="button"
                          class="uk-button uk-button-small-padding uk-button-border uk-width-1-1"
                          data-uk-tooltip="title: Reset all changes; pos: right; offset: 15">
                          <md-icon class="material-symbols-outlined">reset_image</md-icon>
                        </button>
                      </div>
                      <div>
                        <button
                          @click="eraser"
                          type="button"
                          :class="{'tm-active': cursor === 'eraser'}"
                          class="uk-button uk-button-small-padding uk-button-border uk-width-1-1"
                          data-uk-tooltip="title: Eraser; pos: right; offset: 15">
                          <md-icon class="material-symbols-outlined">ink_eraser</md-icon>
                        </button>
                      </div>
                      <div>
                        <button
                          @click="undo"
                          type="button"
                          class="uk-button uk-button-small-padding uk-button-border uk-width-1-1"
                          data-uk-tooltip="title: Step back; pos: right; offset: 15">
                          <md-icon class="material-symbols-outlined">undo</md-icon>
                        </button>
                      </div>
                      <div>
                        <button
                          @click="redo"
                          type="button"
                          class="uk-button uk-button-small-padding uk-button-border uk-width-1-1"
                          data-uk-tooltip="title: Step forward; pos: right; offset: 15">
                          <md-icon class="material-symbols-outlined">redo</md-icon>
                        </button>
                      </div>
                      <div>
                        <button
                          @click="toggleBeforeAfterModeEdit()"
                          type="button"
                          class="uk-button uk-button-small-padding uk-button-border uk-width-1-1"
                          :class="{'tm-active': beforeVisibleModeEdit}"
                          data-uk-tooltip="title: Before photo; pos: right; offset: 15">
                          <md-icon class="material-symbols-outlined">collections</md-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!--фото блок-->
                <div class="uk-width-expand uk-animation-slide-left-small">
                  <div>
                    <div v-show="afterVisibleModeEdit">
                      <div class="uk-width-auto">
                        <div class="canvas-wrapper">
                          <canvas
                            id="backgroundCanvas"
                            :width="imageWidth"
                            :height="imageHeight"/>
                          <canvas
                            id="myCanvas"
                            :class="changeCursor()"
                            :width="imageWidth"
                            :height="imageHeight"
                            @mousemove="action"
                            @mousedown="beginAction"
                            @mouseup="stopAction"/>
                        </div>
                      </div>
                    </div>
                    <div v-show="beforeVisibleModeEdit">
                      <div class="uk-width-auto">
                        <div class="uk-inline-clip uk-transition-toggle tm-block-img 4">
                          <img class="main-photo" :src="main_photo_before" alt="before" style="min-height: 100%;">
                        </div>
                      </div>
                    </div>
                    <!--блок подписи фото-->
                    <div class="uk-grid uk-grid-small uk-flex-middle uk-margin-xsmall-top uk-animation-slide-small-medium 1" data-uk-grid>
                      <div>
                        <div class="tm-left-photo-hover-description">
                          <div class="uk-text-truncate">
                            <template>
                              {{ descriptionModeEdit }}
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--правая часть-->
          <div class="uk-width-1-4" style="height: calc(100vh - 20px);">
            <!--шапка-->
            <order-card-head
              :order_number="order_number"
              :new_orders_count="parentNewOrdersCount"
              :main_photo_before_with_faces="main_photo_before_with_faces"
              @visible="withFacesVisible = $event"
              @visible-after="afterVisible = $event"
              @auto_order_check="auto_order_check = $event"
              :role="'pro-retoucher'"/>
            <div class="uk-panel-scrollable" style="height: calc(100vh - 75px);resize: none;padding: 0;border: none;padding-left: 30px;margin-left: -30px;">
              <!--описание заказа-->
              <ProRetouchersInfoBlock
                v-if="createInfoBlock"
                :order_id="order_id"
                :main_photo_before_with_faces="main_photo_before_with_faces"
                :how_much_orders="how_much_orders"
                :prev_status_order="prev_status_order"
                :main_photo_after="main_photo_after"
                :main_photo_before="main_photo_before"
                :appVersion="computedAppVersion"
                :resolution="resolution"
                :canvasWidth="canvasWidth"
                :canvasHeight="canvasHeight"
                :permission="statusesForEditingOfFunctions.includes(prev_status_order) ? null : 'read'"
                @zone-visible="zoneVisible = $event"
                @after-visible="afterVisible = $event"
                @zone_photo="zone_photo = $event"
                @loading="infoloading = $event"
                @order_cost_credits="cost = $event"
                @faces="faces = $event"
                @with-faces-visible="withFacesVisible = $event"/>
              <!--отметка NEWBIE-->
              <div v-if="junior_order" class="uk-margin-small uk-label uk-label-warning uk-display-block uk-text-center">
                NEWBIE
              </div>
              <!--режим цветных отметок-->
              <CommentPhotoNote
                v-if="modeEdit"
                :fixedPhoto="fixedPhoto"
                :faces="faces"
                :local_page_keys="local_page_keys"
                :prev_status_order="prev_status_order"
                :auto_order_check="auto_order_check"
                :role="role"
                :orderId="order_id"
                :colors="colors"
                :cursor="cursor"
                :color="color"
                :history="history"
                :selectedRetoucherHeader="selectedRetoucherHeader"
                :selectedRetoucher="selectedRetoucher"
                :rejectedToAnotherRetoucher="rejectedToAnotherRetoucher"
                :visibleColor="visibleColor"
                :whichRetoucher="computedWhichRetoucher"
                @closeModeEdit="closeModeEdit"
                @reload="reLoadPage"
                @setCursor="cursor = $event"
                @setColor="color = $event"
                @setText="fixedPhoto.fields[$event.color] = $event.text"
                @deleteColor="deleteColor($event)"
                @setColors="colors = $event"
                @setVisibleColor="visibleColor[$event.color] = $event.value"
                @reset="resetNotes"
                @writeRejectedOrder="writeRejectedOrder"/>
              <!--чат-->
              <div @mouseleave="isOutChat = true"  @mousemove="isOutChat = false">
                <ChatBlock
                  :validateRating="isValidateRate"
                  :infoloading="infoloading"
                  v-if="order_chat !== '' && user"
                  :order_chat="!Array.isArray(order_chat) ? Object.values(order_chat) : order_chat"
                  :faces="faces"
                  :order_id="Number (order_id)"
                  :user="user.email"
                  :role="user.role"
                  :enableAccording = modeEdit
                  @zone-visible="zoneVisible = $event"
                  @after-visible="afterVisible = $event"
                  @zone_photo="zone_photo = $event"
                  @loading="infoloading = $event"
                  ref="childRefChat"/>
              </div>
              <!--кнопки-->
              <ActivitiesOfProRetoucher
                v-if="createButtonsBlock"
                :local_page_keys="local_page_keys"
                :loading="infoloading"
                :faces="faces"
                :order_id="order_id"
                :main_photo_after="main_photo_after"
                :main_photo_before="main_photo_before"
                :canvasWidth="canvasWidth"
                :canvasHeight="canvasHeight"
                :prev_status_order="prev_status_order"
                :download_task_status="download_task_status"
                :order_number="order_number"
                :cost="cost"
                :junior_order="junior_order"
                :role="role"
                :modeEdit="modeEdit"
                :auto_order_check="auto_order_check"
                :showCompleteOrderButton="showCompleteOrderButton"
                :isValidateRate="isValidateRate"
                :permission="statusesForEditingOfFunctions.includes(prev_status_order) ? null : 'read'"
                @isLoading="isLoading = $event"
                @setModeEdit="modeEdit = $event"
                @reload="reLoadPage"
                @checkValidateRating="validateRating"
                @setSelectedRetoucherHeader="selectedRetoucherHeader = $event"
                @setSelectedRetoucher="selectedRetoucher = $event"
                @setRejectedToAnotherRetoucher = "rejectedToAnotherRetoucher = $event"
                @setCheckboxCheckboxWithoutReasonValue = "checkboxCheckboxWithoutReasonValue = $event"
                @writeRejectedOrder="writeRejectedOrder"
                @whichRetoucher="whichRetoucher = $event"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Preloader from "@/pages/Dashboard/Components/Preloader";
import PrevOrdersBlock from "@/pages/Dashboard/Components/PrevOrdersBlock";
import OrderCardHead from "@/pages/Dashboard/Components/OrderCardHead";
import ProRetouchersMainPhotoBlock from "@/pages/Dashboard/Components/for_pro_retouchers/ProRetouchersMainPhotoBlock";
import ProRetouchersInfoBlock from "@/pages/Dashboard/Components/for_pro_retouchers/ProRetouchersInfoBlock";
import ProRetouchersInactivityTimer from "@/pages/Dashboard/Components/for_pro_retouchers/ProRetouchersInactivityTimer";
import ActivitiesOfProRetoucher from "@/pages/Dashboard/Components/for_pro_retouchers/ActivitiesOfProRetoucher";
import ChatBlock from "@/pages/Dashboard/Components/ChatBlock";
import CommentPhotoNote from "@/pages/Dashboard/Components/for_pro_retouchers/CommentPhotoNote";
import responsiveMixin from '@/mixins/responsiveMixin';

export default {
  name: 'ProRetouchersOrderCheck',
  data: () => ({
    createButtonsBlock: false,
    infoloading: true,
    createdowntime: false,
    createPrevBlock: false,
    createHistoryBlock: false,
    creteMainPhotoBlock: false,
    createInfoBlock: false,
    main_photo_block: null,
    main_photo_before_with_faces: null,
    afterVisible: true,
    downtime: null,
    withFacesVisible: false,
    zoneVisible: false,
    zone_photo: null,
    modal_photo: null,
    orderStatus: '',
    empty_order: '',
    isLoading: true,
    whichRetoucher: {},
    order_number: '',
    order_id: null,
    modal_photo_before_with_faces: '',
    faces: [],
    local_page_keys: {},
    order_chat: '',
    my_email: '',
    cost: 0,
    resolution:null,
    junior_order: false,
    main_photo_after: null,
    main_photo_before: null,
    prev_status_order: null,
    download_task_status: null,
    how_much_orders: null,
    role: '',
    new_orders_count: 0,
    intervalNewOrders: null,
    is_orders_to_work: true,
    user: '',
    auto_order_check: null,
    statusesForEditingOfFunctions: ['hold-admin-new', 're-done-customer'],
    getterKey: 0,
    isValidateRate: true,
    fullImageList: {},
    isOutChat: true,
    modeEdit: false,
    fixedPhoto: {
      image: null,
      fields: {'blue': null, 'red': null, 'green': null, 'black': null, 'orange': null},
    },
    colors: [],
    cursor: 'pencil',
    color: 'orange',
    history: [],
    selectedRetoucherHeader: null,
    selectedRetoucher: null,
    rejectedToAnotherRetoucher: null,
    isReset: false,
    comment: '',
    canvas: null,
    backgroundcanvas: null,
    startX: 0,
    startY: 0,
    isDrawing: false,
    isErasing: false,
    imageWidth: 0,
    imageHeight: 0,
    points: [],
    stroke: [],
    backgroundImage: null,
    correction: 1,
    lineWidth: 3,
    lineJoin: 'round',
    shadowColor: '#ffffff',
    canvasWidth: 960,
    canvasHeight: 618,
    snapshots: [],
    snapshotIndex: 0,
    visibleColor: {},
    descriptionModeEdit:'no data',
    beforeVisibleModeEdit:false,
    afterVisibleModeEdit: true,
    orderPhotoAfterUrlLast: null,
    checkboxCheckboxWithoutReasonValue: false,
    srcImage:''
  }),
  components: {
    PrevOrdersBlock,
    Preloader,
    ChatBlock,
    OrderCardHead,
    ProRetouchersMainPhotoBlock,
    ProRetouchersInfoBlock,
    ProRetouchersInactivityTimer,
    ActivitiesOfProRetoucher,
    CommentPhotoNote,
  },
  mixins: [responsiveMixin],
  methods: {
    async fetchMainPhotoBlock() {
      try {
        let data = null;
        if (this.role === 'test-retoucher') {
          await this.$store.dispatch("order/mainPhotoBlockForRetoucher", 'pro-retoucher');
        } else {
          await this.$store.dispatch("order/mainPhotoBlockForRetoucher");
        }
        this.clearCanvas()
        data = await this.$store.getters['order/mainPhotoBlock'];
        if (data) {
          if (typeof (data) !== 'string') {
            this.main_photo_before_with_faces =  !this.isURL(data.main_photo_before_with_faces) ? process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + data.main_photo_before_with_faces: data.main_photo_before_with_faces;
            this.resolution = data.resolution;
            this.appVersion = data.app;
            this.order_number = data.order_number;
            this.order_id = data.order_id;
            this.junior_order = data.test_order

            this.main_photo_block = data;
            this.creteMainPhotoBlock = true;
            this.createInfoBlock = true;
            this.createHistoryBlock = true;
            this.createPrevBlock = true;
            setTimeout(() => {
              this.createButtonsBlock = true;
            }, 2000)
            this.prev_status_order = data.prev_status_order;
            this.download_task_status = data.download_task_status;
            this.how_much_orders = data.how_much_orders;
            if (Object.keys(data).includes('main_photo_after')) {
              this.main_photo_after = data.main_photo_after;
              this.canvasWidth = data.main_photo_after_width === '' ? this.canvasWidth : data.main_photo_after_width;
              this.canvasHeight = data.main_photo_after_height === '' ? this.canvasHeight : data.main_photo_after_height;
              this.main_photo_before = this.isURL(data.main_photo_before) ? data.main_photo_before : process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + data.main_photo_before;
            } else {
              this.main_photo_before = data.main_photo_before;
              this.canvasWidth = data.main_photo_before_width === '' ? this.canvasWidth : data.main_photo_after_height;
              this.canvasHeight = data.main_photo_before_height === '' ? this.canvasHeight : data.main_photo_before_height;
              this.afterVisibleModeEdit = false;
              this.beforeVisibleModeEdit = true;
            }
            this.fullImageList = data.order_photo_file_list;
            this.orderPhotoAfterUrlLast = data.order_photo_after_url_last;
            this.descriptionModeEdit = this.parseFileNameForModeEdit(this.orderPhotoAfterUrlLast)
            this.srcImage = (this.fixedPhoto.image) ? this.fixedPhoto.image : (this.main_photo_after !== null ? this.main_photo_after : this.main_photo_before);
            await this.fetchChatBlock();
          } else {
            this.empty_order = data;
            this.createdowntime = true;
          }
        } else {
          this.errors = this.local_page_keys.alert_failed_main_photo_block;
        }
      } catch (e) {
        alert(e);
      }
      this.isLoading = false;
    },
    /**
     * Method for get data of unclosed downtime and availability of new orders in the queue
     * from DowntimeController (method index)
     * identifiable data: isLoading - define as false
     *                    orderStatus - type: string - if there is unclosed downtime defined as 'done'
     **/
    async fetchDowntime() {
      try {
        let data = null;
        await this.$store.dispatch("order/downtimeProRetoucher");
        data = await this.$store.getters['order/downtimeProRetoucher'];
        if (data) {
          this.new_orders_count = data.new_orders_count;
          this.$nextTick(() => {
            this.new_orders_count = data.new_orders_count;
          });
          if (data.order_in_work === true) {
            this.downtime = null;
            await this.fetchMainPhotoBlock();
          } else {
            this.downtime = data;
            if (!this.is_orders_to_work && data.is_orders_to_work) {
              let audio = new Audio('/audio/juntos-607.mp3');
              audio.play();
              this.is_orders_to_work = data.is_orders_to_work;
            } else {
              this.is_orders_to_work = data.is_orders_to_work;
            }
          }
        } else {
          this.errors = this.local_page_keys.alert_failed_downtime;
        }

      } catch (e) {
        alert(e);
      }
      this.isLoading = false;
    },
    async fetchChatBlock() {
      try {
        let data;
        await this.$store.dispatch("order/historyBlock", this.order_id);
        data = await this.$store.getters["order/historyBlock"];
        if (data.status === 'ok') {
          this.order_chat = data.chat !== '' ? JSON.parse(data.chat) : '';
        } else {
          this.errors = this.local_page_keys.alert_failed_historyBlock;
          this.loading = false;
        }
      } catch (e) {
        alert(e);
      }
    },
    reLoadPage() {
      this.isLoading = true;
      this.order_chat = '';
      this.main_photo_before = null;
      this.main_photo_after = null;
      this.creteMainPhotoBlock = false;
      this.createInfoBlock = false;
      this.createPrevBlock = false;
      this.createButtonsBlock = false;
      this.order_chat = '';
      this.junior_order = false;
      this.fetchDowntime();
    },
    async fetchCountNewOrders () {
      let data;
      await this.$store.dispatch('order/countNewOrdersPro');
      data = await this.$store.getters['order/countNewOrdersPro'];
      this.new_orders_count = data.new_orders_count ? data.new_orders_count : 0;
    },
    validateRating() {
      this.isValidateRate =  this.$refs.childRefChat.validateRatingForProRetoucher('action');
    },
    closeModeEdit() {
      this.collapsed = false;
      this.modeEdit = false;
      this.beforeVisibleModeEdit = false;
      this.afterVisibleModeEdit = true;
    },
    resetNotes() {
      this.fixedPhoto.fields = {'blue': null, 'red': null, 'green': null, 'black': null, 'orange': null};
      this.fixedPhoto.image = null;
      this.colors = [];
      this.cursor = 'pencil';
      this.color = 'orange';
      this.history = [];
      this.snapshots = [];
      this.snapshotIndex = 0;
      this.setSnapshot();
      this.initVisibleColor();
    },
    action(e) {
      if (this.cursor === 'eraser') {
        this.color = '';
        this.erased(e);
      } else {
        this.draw(e);
      }
    },
    async beginAction(e) {
      if (this.cursor === 'eraser') {
        this.color = '';
        this.beginErase(e);
      } else {
        this.beginDrawing(e);
      }
    },
    stopAction(e) {
      if (this.cursor === 'eraser') {
        this.stopErasing(e);
      } else {
        this.stopDrawing(e);
      }
      //this.setImage();
    },
    drawLine(x1, y1, x2, y2) {
      let ctx = this.canvas;
      ctx.beginPath();
      ctx.strokeStyle = this.color;
      ctx.lineWidth = this.lineWidth;
      ctx.lineJoin = this.lineJoin;
      ctx.shadowOffsetX = 1;
      ctx.shadowOffsetY = 1;
      ctx.shadowBlur = 5;
      ctx.shadowColor = this.color;//this.shadowColor;
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
      ctx.closePath;
    },
    draw(e) {
      if (this.isDrawing && this.color !== '') {
        this.drawLine(this.startX * this.correction, this.startY * this.correction, e.offsetX * this.correction, e.offsetY * this.correction);
        this.startX = e.offsetX;
        this.startY = e.offsetY;
        this.points.push({
          x: e.offsetX * this.correction,
          y: e.offsetY * this.correction,
        });
      }
    },
    beginErase(e) {
      this.isErasing = true;
    },
    eraseLine(x, y) {
      let radius = 8;
      let diameter = radius * 2;
      let frontimgdata = this.canvas.getImageData(x - radius, y - radius, diameter, diameter);
      let backimgdata = this.backgroundcanvas.getImageData(x - radius, y - radius, diameter, diameter);
      let count = diameter * diameter * 4;
      let i = 0;
      let m, n, bc, ab;
      while (i <= count) {
        m = i / 4;
        if (m < diameter) {
          n = 0;
        } else {
          n = 0;
          while (m >= diameter) {
            m -= diameter;
            n++;
          }
        }
        bc = radius - m;
        if (bc < 0) {
          bc = -bc;
        }
        ab = radius - n;
        if (ab < 0) {
          ab = -ab;
        }

        if (Math.sqrt(bc * bc + ab * ab) < radius) {
          frontimgdata['data'][i] = backimgdata['data'][i];
          frontimgdata['data'][i + 1] = backimgdata['data'][i + 1];
          frontimgdata['data'][i + 2] = backimgdata['data'][i + 2];
          frontimgdata['data'][i + 3] = backimgdata['data'][i + 3];
        }
        i += 4;
      }
      this.canvas.putImageData(frontimgdata, x - radius, y - radius);
    },
    erased(e) {
      if (this.isErasing) {
        //this.eraseLine(this.startX, this.startY);
        this.eraseLine(this.startX * this.correction, this.startY * this.correction, e.offsetX * this.correction, e.offsetY * this.correction);
        this.startX = e.offsetX;
        this.startY = e.offsetY;
        this.points.push({
          x: e.offsetX * this.correction,
          y: e.offsetY * this.correction,
        });
      }
    },
    stopErasing(e) {
      this.isErasing = false;
      if (this.points.length !== 0) {
        this.stroke['erased'] = [this.points];
        this.history.push(this.stroke);
        this.colors.push('erased');
        this.points = [];
        this.points.length = 0;
        this.stroke = [];
        this.stroke.length = 0;
        this.setSnapshot();
        this.setImage();
      }
    },
    beginDrawing(e) {
      if (this.color !== '') {
        this.startX = e.offsetX;
        this.startY = e.offsetY;
        this.isDrawing = true;
      }
    },
    stopDrawing(e) {
      if (this.isDrawing) {
        this.drawLine(this.startX, this.startY, e.offsetX, e.offsetY);
        this.startX = 0;
        this.startY = 0;
        this.isDrawing = false;
        if (this.points.length > 0) {
          this.stroke[this.color] = [this.points];
          this.history.push(this.stroke);
          this.colors.push(this.color);
          this.points = [];
          this.points.length = 0;
          this.stroke = [];
          this.stroke.length = 0;
          this.setSnapshot();
          this.setImage();
        }
      }
    },
    resetCanvas() {
      const {width, height} = this.init();
      this.canvas.clearRect(0, 0, width, height);
      this.canvas.drawImage(this.backgroundImage, 0, 0, width, height);
      this.points.length = 0;
      this.cursor = '';
      this.resetNotes();
    },
    setImage() {
      const myCanvas = document.querySelector('#myCanvas');
      const dataURI = myCanvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
      let convertImg = new Image();
      convertImg.src = dataURI;
      this.fixedPhoto.image = dataURI
    },
    undo() {
      if (this.snapshotIndex > 0) {
        this.snapshotIndex -= 1;
        this.setFromSnapshot();
      }
    },
    redo() {
      if (this.snapshots[this.snapshotIndex + 1]) {
        this.snapshotIndex += 1;
        this.setFromSnapshot();
      }
    },
    redraw(history) {
      const {width, height} = this.init();
      this.canvas.clearRect(0, 0, width, height);
      this.canvas.drawImage(this.backgroundImage, 0, 0, width, height);
      history.forEach((value) => {
        let strokes = Object.entries(value);
        strokes.forEach(stroke => {
          let currcolor = stroke[0];
          if (currcolor !== 'erased') {
            stroke[1].forEach(points => {
              let ctx = this.canvas;
              let began = points.at(0);
              ctx.beginPath();
              ctx.strokeStyle = currcolor;
              ctx.moveTo(began.x, began.y);
              points.forEach((point) => {
                ctx.lineTo(point.x, point.y);
              })
              ctx.stroke();
              ctx.closePath;
            })
          } else {
            stroke[1].forEach(points => {
              points.forEach((point) => {
                this.eraseLine(point.x, point.y);
              })
            })
          }
        })
      })
    },
    init() {
    //  const canvas = document.getElementById("myCanvas");
      const canvasWrapper = document.querySelector('.canvas-wrapper');
      const widthWrapper = parseInt(window.getComputedStyle(canvasWrapper).width);
    //  const widthWrapper = 1354.5;
      const heightWrapper = parseInt(window.getComputedStyle(canvasWrapper).height);
      if ((widthWrapper < this.canvasWidth) && this.canvasWidth > this.canvasHeight) {
        this.imageWidth = widthWrapper;
        this.imageHeight = Math.ceil((widthWrapper * this.canvasHeight) / this.canvasWidth);
      } else if (this.canvasHeight >= this.canvasWidth) {
        this.imageHeight = heightWrapper;
        this.imageWidth = Math.floor((heightWrapper * this.canvasWidth) / this.canvasHeight);
      } else {
        this.imageHeight = heightWrapper;
        this.imageWidth = Math.floor((heightWrapper * this.canvasWidth) / this.canvasHeight);
        //Компенсация искажения линии после изменения ширины
        // this.correction = heightWrapper / widthWrapper;
      }
      return {
        width: this.imageWidth,
        height: this.imageHeight
      }
    },
    changeCursor() {
      return this.cursor;
    },
    eraser() {
      this.cursor = 'eraser';
    },
    deleteColor(color) {
      if (this.colors.filter(item => item === color).length > 0) {
        this.colors = this.colors.filter(item => item !== color);
        this.history = this.history.filter(innerArray => Object.keys(innerArray).some(key => key !== color));
        this.color = '';
        this.cursor = '';
        this.fixedPhoto.fields[color] = null;
        this.redraw(this.history);
        this.setSnapshot();
        this.setImage();
      }
    },
    setSnapshot() {
      const historyCopy = [...this.history];
      const colorsCopy = [...this.colors];
      const textsCopy = {...this.fixedPhoto.fields};

      this.snapshots.push({
        'history': historyCopy,
        'colors': colorsCopy,
        'texts': textsCopy,
        'color': this.color,
        'cursor': this.cursor
      });
      this.snapshotIndex = this.snapshots.length > 0 ? this.snapshots.length - 1 : 0;
    },
    setFromSnapshot() {
      if (this.snapshots[this.snapshotIndex]) {
        this.history = this.snapshots[this.snapshotIndex].history;
        this.colors = this.snapshots[this.snapshotIndex].colors;
        this.color = this.snapshots[this.snapshotIndex].color;
        this.cursor = this.snapshots[this.snapshotIndex].cursor;
       // this.fixedPhoto.fields = this.snapshots[this.snapshotIndex].texts;
        this.redraw(this.history);
      }
    },
    initVisibleColor() {
      this.visibleColor = {'blue': true, 'red': true, 'green': false, 'black': false, 'orange': true};
    },
    parseFileNameForModeEdit(file) {
      if (!file)
        return '';
      //https://retoucher.app:10001/storage/order_photos/1002825548/order_photo_before_url.jpg
      if (file.includes("order_photo_before_url")) {
        return this.local_page_keys.description_photo_marking_before;
      }
      if (file.includes("order_photo_")) {
        const regex = /order_photo_after_(\d+)/;
        const match = file.match(regex);
        const number = match ? match[1] : '';
        return this.local_page_keys.description_photo_marking_after + ' ' + number;
      }
    },
    toggleBeforeAfterModeEdit(){
      if (this.main_photo_after) {
        this.afterVisibleModeEdit = !this.afterVisibleModeEdit;
        this.beforeVisibleModeEdit = !this.beforeVisibleModeEdit;
      }
    },
    async writeRejectedOrder() {
      let retoucher_email = typeof this.selectedRetoucherHeader == 'string' ? this.selectedRetoucherHeader : null;
      let payload = new FormData();
      payload.append('auto_order_check', new Number(this.auto_order_check).toString());
      //payload.append('education', new Number(this.education).toString());

      if (this.selectedRetoucher == this.local_page_keys.select_another_retoucher) {
        payload.append('retoucher_status', 'rejected-to-another-retoucher');
        payload.append('without_reason', this.checkboxCheckboxWithoutReasonValue);
        payload.append('message', this.local_page_keys.chat_rejected_to_another_retoucher);
        retoucher_email = this.rejectedToAnotherRetoucher;
      }
      payload.append('retoucher_email', retoucher_email);

      if (this.role === 'test-retoucher') {
        await this.$store.dispatch("postProRetoucher/writeRejected", {data: payload, role: 'pro-retoucher'});
      } else {
        await this.$store.dispatch("postProRetoucher/writeRejected", payload);
      }
      let data = await this.$store.getters['postProRetoucher/writeRejected'];
      if (data.status !== 'ok') {
        alert(data.message);
        return;
      }
      return data;
    },
    isURL(str) {
      if(!str)
        return false;

      return str.startsWith('http://') || str.startsWith('https://');
    },
    clearCanvas() {
      const canvas = document.getElementById('myCanvas');
      const context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);

      let bc = document.getElementById("backgroundCanvas");
      const contextBc = bc.getContext('2d');
      contextBc.clearRect(0, 0, contextBc.width, contextBc.height);

     this.fixedPhoto.image = null
     this.fixedPhoto.fields = {'blue': null, 'red': null, 'green': null, 'black': null, 'orange': null};
    }

  },
  computed: {
    computedWhichRetoucher(){
      return this.whichRetoucher;
    },
    computedAppVersion(){
      return this.appVersion;
    },
    parentNewOrdersCount() {
      return this.new_orders_count;
    },
    showCompleteOrderButton() {
      if (this.role !== 'pro-retoucher')
        return true;
      if (this.order_chat) {
        const searchString = "redo client";
        const limit = 3;
        const count = this.order_chat.filter(item => item.name === searchString).length;
        return count > limit;
      }
      return false;
    },
  },
  async created() {
    this.local_page_keys = await this.$filtergetLocalisationPages(['order-orderCheck', 'order-comment-photo','order-photo-block']);
    this.role = await this.$store.getters['profile/role'];
    await this.$store.dispatch('profile/me');
    this.getterKey++;
    this.user = await this.$store.getters['profile/me'](this.getterKey);
    await this.fetchDowntime();
    if (typeof this.new_orders_count == 'undefined') {
      await this.fetchCountNewOrders();
      if (this.role === 'pro-retoucher') {
        this.intervalNewOrders = setInterval(() => {
          this.fetchCountNewOrders();
        }, 10000);
      }
    }
    this.setSnapshot();
    this.initVisibleColor()
  },
  watch: {
    modeEdit: function (newVal) {
      //this.clearCanvas();
     // if (newVal && this.history.length === 0) {
      if (newVal) {
        setTimeout(() => {
          const {width, height} = this.init();
          let c = document.getElementById("myCanvas");
          this.canvas = c.getContext('2d');
          let bc = document.getElementById("backgroundCanvas");
          this.backgroundcanvas = bc.getContext('2d');
          let bctx = this.backgroundcanvas;
          let ctx = this.canvas;
          let re = "raw=1";
          let image = new Image(width, height);
          if (this.srcImage.includes(re)) {
            image.crossOrigin = '*';
          }
          image.onload = drawImageActualSize;
          image.src = this.srcImage;
          this.backgroundImage = image;

          function drawImageActualSize() {
            ctx.drawImage(this, 0, 0, width, height);
            bctx.drawImage(this, 0, 0, width, height);
          }
        }, 300);
      }
      if (newVal) {
        this.collapsed = true;
      }
    },
    afterVisibleModeEdit: function (newVal) {
      if (newVal) {
        this.descriptionModeEdit = this.parseFileNameForModeEdit(this.orderPhotoAfterUrlLast)
      }
    },
    beforeVisibleModeEdit: function (newVal) {
      if (newVal) {
        this.descriptionModeEdit = this.parseFileNameForModeEdit(this.main_photo_before)
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalNewOrders);
  }
}
</script>
<style scoped>
.tm-file-name {
  word-break: break-all;
  line-height: 1;
}

.prev-img {
  width: 60px;
  height: 60px;
  background-color: #ccc
}

#files-area {
  border-radius: 6px;
  border: 3px dashed #e8e8e8;
  background-color: #f5f5f5;
  min-height: 100px;
}

.file-block {
  overflow: hidden;
  border-radius: 6px;
  background-color: rgba(144, 163, 203, 0.2);
  margin: 5px 0;
}

.tm-file-delete {
  cursor: pointer;
  padding: 10px;
}

/*.tm-button-add {*/
/*  padding: 0 9px;*/
/*  border-radius: 50px;*/
/*}*/

.main-photo-dialog {
  height: 100%;
}

.left-part-main-photo {
  width: 100%;
}

.buttons {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.comments-button {
  border: #297a96 2px solid;
  border-radius: 5px;
  width: 75%;
  height: 90%;
  background: none;
  color: #3e3d3d;
  margin: 2px;
}

.scrollable-dialog {
  max-height: 80% !important;
  overflow-y: auto;
}

.checkFunctions {
  display: contents;
}

.image-compare-handle {
  color: #f10404;
  background-color: currentColor;
  cursor: ew-resize;
  transform: translateX(-50%) translateZ(0);
  width: 2px;
  z-index: 2;
  will-change: left;

}

.display {
  display: none;
}

.cancel-order {
  margin: auto;
}


#myCanvas {
  background-color: #d7d7d7;
  z-index: 1;
}

#backgroundCanvas {
  position: absolute;
  z-index: 0;
}

.pencil {
  cursor: url(/img/pencil-cursor.png) 0 0, crosshair;
}

.eraser {
  cursor: url(/img/eraser_new.png) 12 40, crosshair;
}

.blueText, .blue {
  color: blue;
}

.redText, .red {
  color: red;
}

.greenText, .green {
  color: green;
}

.blackText, .black {
  color: black;
}

.orangeText, .orange {
  color: orange;
}

.comment-photo-class {
  display: flex;
  flex-direction: row;
}

.canvas-section {
  display: flex;
  flex-direction: column;
}

.canvas-buttons .uk-button {
  border-radius: 0;
  border: #a9a9a9 2px solid;
}

.canvas-buttons .uk-button:hover,
.canvas-buttons .uk-button:focus {
  background-color: #eee;
}

.canvas-buttons .reset-button {
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  background: #a9a9a9;
  color: #fff;
}

.canvas-buttons .save-button {
  background: #4caf50;
  border: #4caf50 2px solid;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  color: #fff;
}

.canvas-buttons .save-button.uk-button:hover,
.canvas-buttons .save-button.uk-button:focus {
  background-color: #3d9340;
  border-color: #3d9340;
}

.canvas-buttons .save-button-disebled {
  background: #a9a9a9;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  color: #fff;
}

.canvas-buttons .reset-button.uk-button:hover,
.canvas-buttons .reset-button.uk-button:focus,
.canvas-buttons .save-button-disebled.uk-button:hover,
.canvas-buttons .save-button-disebled.uk-button:focus {
  background-color: #888;
  border-color: #888;
}

.eraser {
  background-color: #eee;
}

.canvas-buttons .eraser.uk-button {
  background-color: rgb(61 147 64 / 50%);
}

.disabled-input {
  /*width: 85%;*/
  border: grey 1px solid;
  padding: 2px;
}

.activeColor {
  background-color: #efefef !important;
  border: 1px solid #b2b2b2 !important;
}
</style>
